export const environment = {
  production: false,
  restaurantId: 'fattyPattyDev',
  firebaseConfig: {
    apiKey: 'AIzaSyDC4156DPTyd_V5kLghALzoqic9zfJ19rQ',
    authDomain: 'fattypatty-dev.firebaseapp.com',
    projectId: 'fattypatty-dev',
    storageBucket: 'fattypatty-dev.firebasestorage.app',
    messagingSenderId: '213846751913',
    appId: '1:213846751913:web:481f9391791159e86687b8',
    measurementId: 'G-HW53X90DBG',
  },
  headerTitle: 'fatty Patty',
  apiUrl: 'https://us-central1-tt-dev-c0bb0.cloudfunctions.net/apiv3',
  mainColor: '#FF7A00',
  facebookLink: 'https://www.facebook.com/TheFattyPattyBurger',
  twitterLink: '',
  instagramLink: 'https://www.instagram.com/thefattypattyburger/',
  yelpLink:
    'https://www.yelp.com/biz/taqwas-bakery-and-restaurant-greenfield?osq=Taqwa',
  phoneNumber: '+1 (414) 550 55 55',
  address: '4651 S 27th St, Greenfield, WI 53221',
  email: 'info@TT.com',
  about: `At a young age, the founders of fattyPattyDev & Restaurant
    discovered the importance of having the right ingredients to
    create the perfect recipe. Taqwa and her husband, the
    restaurant founders, collaborated and utilized their
    techniques to craft delicious Middle Eastern cuisine that
    delighted their loved ones.`,

  isRoot: false,
  primaryColor: '#C7A17A',
  secoundaryColor: '#FAFAFA',
  darkGreyColor: '#302F3C',
  darkBlueColor: '#172B4D',
  grayBlueColor: '#7A869A',
  darkgrayBlueColor: '#323643',
  footerColor: '#2B2B2B',
  shapeBlueColor: '#42526E',
  appGooglePayLink: '',
  appappleStoreLink: '',
  currency: ' $ ',

  squareApplicationId: 'sandbox-sq0idb-wdZjJsduDq4mB4CpioS9Dw',
  squareLocationId: 'L44EEMZ6XH1SA',

  googleMapsApiKey: 'AIzaSyBtyCpXFR-KuklKHbtekvajde7AAoapGeE',
  squareScriptUrl: 'https://sandbox.web.squarecdn.com/v1/square.js',
};
